const MESSAGE_UNSET = "message:unsent";
const MESSAGE_SENT = "message:sent";
const UPGRADE_LEVEL2 = "upgrade:level2";
const UPGRADE_LEVEL3 = "upgrade:level3";
const FRIEND_REQUEST = "friend:request";
const FRIEND_ACCEPT = "friend:accept";
const FEED_LIKE = "feed:like";
const FEED_COMMENT = "feed:comment";
const FORUM_LIKE = "forum:like";
const FORUM_COMMENT = "forum:comment";
const COMPLAINT_NEW = "complaint:new";

export {
  MESSAGE_SENT,
  MESSAGE_UNSET,
  UPGRADE_LEVEL2,
  UPGRADE_LEVEL3,
  FRIEND_REQUEST,
  FRIEND_ACCEPT,
  FEED_LIKE,
  FEED_COMMENT,
  FORUM_LIKE,
  FORUM_COMMENT,
  COMPLAINT_NEW,
};
